module.exports = __webpack_public_path__ + "static/media/Ingresos.950a1ebd.svg";